import { render, staticRenderFns } from "./RoomConfig.vue?vue&type=template&id=668cf31e&"
import script from "./RoomConfig.vue?vue&type=script&lang=js&"
export * from "./RoomConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports